import ajax from "../../lib/ajax"
import util from "../../lib/util"
import { Store, Module, ActionContext } from "vuex"
// import { AbpApiResponse } from "../models/common"
// import { GetCurrentLoginInformationsOutput } from "../models/session/GetCurrentLoginInformationsOutput"
import AppConsts from "@/lib/appconst"
import { GetNotificationsOutput, UserNotification, IUserLoginInfoDto } from "@/asdcom/apiproxy/apiproxy.dto"
interface SessionState {
  userName?: string,
  newNotifCount: number,
  newNotifications?: UserNotification[],
  currentClaim: any;
}
class SessionStore implements Module<SessionState, any> {
  namespaced = true
  state = {
    userName: "",
    newNotifCount: 0,
    newNotifications: [],
    currentClaim: null,

  }
  getters = {
    // moved from "session"
    tokenDurationSeconds(context: SessionState) {
      const seconds = localStorage.getItem(AppConsts.authorization.tokenDurationSecondsName)
      return seconds
    },
    tokenExpiration(context: SessionState) {
      const exp = localStorage.getItem(AppConsts.authorization.tokenExpName)
      return exp
    },
    useFillButton(context: SessionState, getters: any, rootState: any, rootGetters: any) {
      return rootState.session.application ? rootState.session.application.useFillButton : null
      //return process.env.NODE_ENV === "production" ? false : true;
    },
    currentUser(context: SessionState, getters: any, rootState: any, rootGetters: any) {
      //console.log("getters session/currentUser called. context.user:", context.user);
      return rootState.session.user
    },
    didTimeout(context: SessionState) {
      return util.abp.utils.getCookieValue(AppConsts.authorization.isTimeoutCookieName) == "true" || false
    },
  }

  mutations = {
    currentClaim(state: SessionState, payload: { claim: any }){
      abp.log.debug({"asdcom.session currentClaim":payload});
      state.currentClaim = payload.claim;
    },

    newNotificationsChanged(state: SessionState, payload: { newNotifications: GetNotificationsOutput }) {
      state.newNotifCount = payload.newNotifications.unreadCount || 0
      state.newNotifications = payload.newNotifications.items
    },

    newSession(state: SessionState, loginInfo: IUserLoginInfoDto) {
      // abp.log.debug({
      //   "newSession called....": {
      //     "state.userName": state.userName,
      //     "state.user": state.user,
      //     tokenExpGetter: store.getters["session/tokenExpiration"],
      //   },
      // })

      // clear timeout flag for new session.
      util.abp.utils.deleteCookie(AppConsts.authorization.isTimeoutCookieName, util.abp.appPath)

      // state.application = payload.loginInfo.application
      // state.user = payload.loginInfo.user
      // state.tenant = payload.loginInfo.tenant
      if (!!loginInfo) {
        state.userName = loginInfo.userName;
      }
    },
  }
  actions = {
    async init(context: ActionContext<SessionState, any>) {
      try {
        abp.log.debug("asdcom/session/init called ***")
        // Get login information.
        // let rep = await ajax.get("/api/services/app/Session/GetCurrentLoginInformations", {
        //   headers: {
        //     "Abp.TenantId": util.abp.multiTenancy.getTenantIdCookie(),
        //   },
        //   params: {
        //     preventCache: new Date().getTime(),
        //   },
        // })
        // let data = rep.data as AbpApiResponse
        // const loginInfo = data.result as GetCurrentLoginInformationsOutput

        // call init from "session" store.
        let rep = await context.dispatch("session/init", {}, { root: true })

        // const loginInfo = context.commit("initSession", { loginInfo: loginInfo })
        const user = context.rootState.session.user as IUserLoginInfoDto
        context.commit("newSession", user)  

        return rep
      } catch (error) {
        abp.log.fatal(error)
      }
    },

    // async getNewNotifications(context: ActionContext<SessionState, any>, maxCount: number): Promise<GetNotificationsOutput> {
    // abp.log.debug({ "vcponlineok/getNewNotifications maxCount": maxCount })

    // const res = await ajax.get<AbpApiResponse<OkNotificationListDto>>(`/api/services/app/VcpOnlineOkService/GetNewNotifications?maxReturnCount=${maxCount}`)
    // /// update store value only when new count is different.
    // if (!!res.data.result) {
    //   if (res.data.result.totalCount !== context.state.newNotifCount) {
    //     context.commit("newNotificationsChanged", { newNotifications: res.data.result })
    //   }
    // }
    // return res.data.result

    // const service = new NotificationServiceProxy()
    // const resp = await service.getUserNotifications(UserNotificationState.Unread, null, null, maxCount, 0)

    // if (resp.unreadCount !== context.state.newNotifCount) {
    //   context.commit("newNotificationsChanged", { newNotifications: resp.items })
    // }
    // return resp
    // },

    //  async getNotifications(context: ActionContext<SessionState, any>): Promise<GetNotificationsOutput> {
    //   abp.log.debug({ "vcponlineok/getNotifications": "" })
    //   // const res = await ajax.get<AbpApiResponse<OkNotificationListDto>>("/api/services/app/VcpOnlineOkService/GetNotifications")
    //   const service = new NotificationServiceProxy()
    //   const resp = await service.getUserNotifications(UserNotificationState.Unread, null, null, undefined, 0)


    //   return resp
    // },

  }
}
const session = new SessionStore()
export default session
